import React from 'react';
import { Dialog } from '@mui/material';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Store } from 'pullstate';
import { PuzzleStoreBase } from '../../../../utils/types';
import './RevealConfirmationDialog.less';

type RevealConfirmationDialogProps = {
  store: Store<PuzzleStoreBase>;
  onReveal: () => void;
};

const RevealConfirmationDialog = ({ store, onReveal }: RevealConfirmationDialogProps) => {
  const isOpen = store.useState(s => s.revealConfirmationIsOpen);

  const onClose = () => {
    store.update(s => {
      s.revealConfirmationIsOpen = false;
      s.isSoftPaused = false;
    });
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <div className="revealConfirmationDialogContent">
        <IconButton className="closeButton" onClick={onClose}>
          <CloseIcon/>
        </IconButton>
        <div className="prompt">
          Are you utterly certain you wish to reveal the solution?
        </div>
        <button className="decisionButton" onClick={onClose}>Cancel</button>
        <button className="decisionButton revealButton" onClick={() => {
          onReveal();
          onClose();
        }}>Reveal</button>
      </div>
    </Dialog>
  );
};

export default RevealConfirmationDialog;